module["exports"] = [
  "España"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/es/address/default_country.js
 ** module id = 483
 ** module chunks = 0
 **/